angular.module('bmsApp.trugreen.job')
	.controller('TGCopyJobModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  TGJobSvc,
				  job) {


			function init() {
				self.job = job;
				self.copyMethod = "1"; // copy and reset
			}


			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				var copyMethod = (self.copyMethod == "1") ? 'copy_rrp' : 'copy_exact';
				var params = {
					jobId: self.job.id,
					method: copyMethod
				};
				TGJobSvc.copy(params).then(function(response) {
					$modalInstance.close(response.data.job);
				});
			}

			var self = $scope.TGCopyJobCtrl = {
				loading: true,
				job: {},
				methods: {
					init: init,
					cancel: cancel,
					submit: submit
				}
			}

		});
